module.exports = "/_next/static/images/visa-7f22160674092df9198803f271940667.jpg";